var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterAltWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12501_99802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.124512,
    width: 24,
    height: 24,
    fill: "#9945EE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12501_99802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.1245C11.2167 20.1245 10.9792 20.0287 10.7875 19.837C10.5958 19.6453 10.5 19.4078 10.5 19.1245V13.1245L4.7 5.72451C4.45 5.39118 4.4125 5.04118 4.5875 4.67451C4.7625 4.30785 5.06666 4.12451 5.5 4.12451H19.5C19.9333 4.12451 20.2375 4.30785 20.4125 4.67451C20.5875 5.04118 20.55 5.39118 20.3 5.72451L14.5 13.1245V19.1245C14.5 19.4078 14.4042 19.6453 14.2125 19.837C14.0208 20.0287 13.7833 20.1245 13.5 20.1245H11.5ZM12.5 12.4245L17.45 6.12451H7.55L12.5 12.4245Z",
    fill: "#9945EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAltWhite);
export default __webpack_public_path__ + "static/media/filter_alt_white.55f2f75ca8ff29cd9e54c0c2f5cf60ff.svg";
export { ForwardRef as ReactComponent };